export const RENET_EMAIL_TEMPLATE = {
  to: 'support@renet.com.au',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello ReNet

Could you please enable Snug as an upload destination for our agency for the ReNet Account(s):

- [Enter your Agency ID here]

Please assign the ReNet Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
